export default "__VITE_ASSET__823beddc__"